import { atom } from "recoil";

export const gameSectionStore = atom({
	key: "gameSectionStore",
	default: {
		loaded: false,
		data: [],
		sorting: {
			sortingColumn: {
				sortingField: "",
			},
			sortingDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
		},
		selectedItems: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
